import { css } from 'styled-components'

import { FlexContainer } from '../../styles/defaults'
import { minmedia } from '../../styles/media-queries'
import { bordergray } from '../../styles/colors'
import { Container as ProductContainer } from '../../components/Product/styles'
import { Container as ProductIntroContainer } from '../../components/ProductIntro/styles'

export const Container = FlexContainer.extend`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  justify-content: flex-start;

  ${minmedia.large`
    margin-bottom: 4rem;
  `} ${ProductIntroContainer} {
    width: 100%;
  }

  ${ProductContainer} {
    width: 100%;
    border-bottom: 1px solid ${bordergray};

    ${props => props.search && css`
      &:nth-of-type(2) {
        border-top: 1px solid ${bordergray};
      }
      &:nth-of-type(odd) {
        border-right: 1px solid ${bordergray};
      }
    `};

    &:nth-of-type(1) {
      border-top: 1px solid ${bordergray};
    }

    @media screen and (min-width: 375px) {
      width: 50%;
      &:nth-of-type(even) {
        border-right: 1px solid ${bordergray};
      }
    }

    @media screen and (min-width: 768px) and (max-width: 1279px) {
      border-right: 1px solid ${bordergray};
      &:nth-of-type(2) {
        border-top: 1px solid ${bordergray};
      }
      &:nth-of-type(3) {
        border-top: 1px solid ${bordergray};
      }
      &:nth-of-type(3n + 1) {
        border-left: 1px solid ${bordergray};
      }
    }

    @media screen and (min-width: 768px) and (max-width: 999px) {
      &:nth-of-type(3n + 0) {
        border-right: 0;
      }
      &:nth-of-type(3n + 1) {
        border-left: 0;
      }
    }

    ${minmedia.xmlarge`
      border-right: 1px solid ${bordergray};
      &:nth-of-type(2) {
        border-top: 1px solid ${bordergray};
      }
      &:nth-of-type(3),
      &:nth-of-type(4) {
        border-top: 1px solid ${bordergray};
      }
      &:nth-of-type(4n+1) {
        border-left: 1px solid ${bordergray};
      }
    `};
  }

  ${ProductContainer}, ${ProductIntroContainer} {
    ${minmedia.medium`
      width: calc(100%/3);
    `} ${minmedia.xmlarge`
      width: 25%;
    `};
  }
`



// WEBPACK FOOTER //
// ./src/containers/ProductGrid/styles.js